const initialDealColumnsData = [{
  title: '基础资产特征',
  dataIndex: 'rowName',
  key: 'feature',
  width: 200,
}];

const initialDealContentData = [{
  key: '1',
  rowName: '平均借款人数',
  render: (text) => {
    return Math.floor(+text);
  }
}, {
  key: '2',
  rowName: '平均借款笔数',
  render: (text) => {
    return Math.floor(+text);
  }
}, {
  key: '3',
  rowName: '单人借款金额(万)',
}, {
  key: '4',
  rowName: '平均贷款年利率',
}, {
  key: '5',
  rowName: '平均贷款剩余期限(年)',
}, {
  key: '6',
  rowName: '当前平均贷款年利率',
}, {
  key: '7',
  rowName: '当前平均贷款剩余期限(年)',
}, {
  key: '8',
  rowName: '年化违约率',
}, {
  key: '9',
  rowName: '年化提前偿还率',
}];

const initialNoteColumnsData = [{
  title: '基础资产特征',
  dataIndex: 'feature',
  key: 'feature',
  width: 200,
}, {
  title: '优先A级证券',
  dataIndex: 'floor_a',
  key: 'floor_a',
  width: 100,
}, {
  title: '优先B级证券',
  dataIndex: 'floor_b',
  key: 'floor_b',
  width: 100,
}];

const initialNoteContentData = [{
  key: '1',
  feature: '发行证券总数',
  average: '136',
  floor_a: '1.56',
  floor_b: '1.00',
}, {
  key: '2',
  feature: '平均分层占比(%)',
  average: '187',
  floor_a: '79.64%',
  floor_b: '9.09%',
}, {
  key: '3',
  feature: '平均利率',
  average: '3,019.86',
  floor_a: '4.37%',
  floor_b: '5.22%',
}, {
  key: '4',
  feature: '平均期限(年)',
  average: '5.86%',
  floor_a: '1.32',
  floor_b: '2.07',
}, {
  key: '5',
  feature: '固定利率证券占比(%)',
  average: '1.56',
  floor_a: '33.03%',
  floor_b: '18.46%',
}, {
  key: '6',
  feature: '浮动利率证券占比(%)',
  floor_a: '66.97%',
  floor_b: '81.54%',
}, {
  key: '7',
  feature: '摊还型证券占比(%)',
  floor_a: '16.89%',
  floor_b: '0.77%',
}];

const ratingColumnsData = [{
  title: '产品位次得分',
  dataIndex: 'feature',
  key: 'feature',
  width: 200,
  colSpan: 2,
  className: 'abs-left',
}, {
  title: '',
  dataIndex: 'average',
  key: 'average',
}, {
  title: '',
  dataIndex: 'product',
  key: 'product',
  width: 200,
}];

const ratingContentData = [{
  key: '1',
  feature: '产品位次综合得分',
  product: '39.77',
}, {
  key: '2',
  feature: '信息披露位次得分',
  product: '0.00',
  average: '123',
}, {
  key: '3',
  feature: '累计违约率位次得分',
  product: '100',
}, {
  key: '4',
  feature: '累计提前偿付位次得分',
  product: '38.64',
}, {
  key: '5',
  feature: '离散度位次得分',
  product: '55.68',
}];

export function generateRandomKey(length: number = 5): string {
  const charset = 'abcdefghijklmnopqrstuvwxyz';
  return Array.from({ length }).reduce((acc, crr) => {
    const index = Math.floor(Math.random() * charset.length);
    return acc + charset[index];
  }, '') as string;
}
export default { initialDealColumnsData, initialDealContentData, initialNoteColumnsData, initialNoteContentData, ratingColumnsData, ratingContentData }; 


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/abs/views/absui/ABSProductCompare/util.ts